<div class="inner-container">
  @if (section().content.title) {
    <div class="title-section inner-container" [innerHTML]="safeTitle"></div>
  }

  <div class="grid" [ngStyle]="{ 'justify-content': getJustifyContent() }">
    @for (tile of items(); track tile.id) {
      <div
        [ngClass]="['col-12', 'md:' + getColClass(section().content.tilesInRow)]"
        [style.cursor]="tile.redirectOnClick ? 'pointer' : 'default'"
        (click)="tile.redirectOnClick && onTileClick(tile)"
        class="tile"
      >
        <div class="tile-container">
          <img [src]="tile.image.url" alt="Tile image" class="tile-image" />
        </div>
      </div>
    }
  </div>
</div>
